import script from "./MeterReading.vue?vue&type=script&setup=true&lang=js"
export * from "./MeterReading.vue?vue&type=script&setup=true&lang=js"

import "./MeterReading.vue?vue&type=style&index=0&id=2dc6f1e4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc6f1e4"]])

export default __exports__